import axios from './clientAxios';
const baseUrl = process.env.VUE_APP_API_BASE_URL;
process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

export default {
    updateToken(query) {
        if(query && query.token) {
            localStorage.setItem('token', query.token)
        }
    },
    get(api) {
        const token = localStorage.getItem('token')
        return axios.get(api,
            {headers: {"x-access-token":token}})
            .then(res => res.data).catch(e => {throw e})
    },
    post(api, data) {
        const token = localStorage.getItem('token')
        return axios.post(api, data, 
            {headers: {"x-access-token":token}})
            .then(res => res.data).catch(e => {throw e})
    },
    web_get(api) {
        const token = localStorage.getItem('token')
        return axios.get(api,
            {headers: {}})
            .then(res => res.data).catch(e => {throw e})
    },
    dosi_post(code) {
        return axios.post('https://api.dosi.world/api/v1/oauth2/token', {
                grant_type: 'authorization_code',
                code: code,
                client_id: 'DM3nloZ2hvfmUhMMO1QT',
                client_secret: 'rq5VIVjfnu',
            }, {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
                transformRequest: [(data) => new URLSearchParams(data).toString()],
            })
            .then(res => res.data).catch(e => {throw e});
    }

}


